<template>
  <div class="create-batch-check-order-job">
    <a-spin :spinning="loading">
      <div class="content flex-ct between" style="min-height: 0">
        <a-tabs default-active-key="OrderStatusFlow" @change="changeTabs">
          <a-tab-pane key="BaseInfo" :tab="$t(`基本信息`)"></a-tab-pane>
          <a-tab-pane key="AmountInfo" :tab="$t(`金额信息`)"></a-tab-pane>
          <a-tab-pane key="InvoiceInfo" :tab="$t(`发票信息`)" v-if="isDetail"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`订单明细`)"></a-tab-pane>
          <a-tab-pane key="WrittenOffInfo" :tab="$t(`核销关系`)" v-if="isDetail"></a-tab-pane>
        </a-tabs>
        <div class="flex-ct" v-show="!loading">
          <OperateBtn
            v-if="$store.getters.hasFunction('payable_review') && formData.status === 'WAIT_CHECK'"
            api="operateDoc"
            :text="$t('审核')"
            :params="{
              action: 'check',
              docType: docType,
              idList: [id],
            }"
            @success="init"
          />
          <PushBtn
            class="ml10"
            v-if="['FINISHED', 'PART_WRITTEN_OFF', 'WAIT_WRITTEN_OFF'].includes(formData.status)"
            :docType="docType"
            :selectedRows="[formData]"
            @pushAdjust="pushAdjust"
          />
          <FindRelatedDocBtn class="ml10" :id="id" :docType="docType" v-if="isDetail" />
          <VoucherBtn
            class="ml10"
            v-if="
              isDetail &&
              !['DRAFT', 'WAIT_CHECK', 'CANCELLED'].includes(formData.status) &&
              !formData.voucherGenerated
            "
            :docType="docType"
            :selectedRows="[formData]"
            @close="init"
          />
          <template v-if="isDetail && formData.invoiceStatus === 'WAIT_INVOICE'">
            <a-button class="ml10" type="primary" @click="createInvoiceHandle">
              <span>{{ $t('创建发票') }}</span>
            </a-button>
            <a-tooltip placement="topLeft">
              <template slot="title">
                {{ $t('将应付单的商品信息带到发票创建页面') }}
              </template>
              <a-icon type="question-circle" class="ml6" />
            </a-tooltip>
          </template>
          <OperateBtn
            class="ml10"
            v-if="isDetail && ['WAIT_CHECK', 'WAIT_WRITTEN_OFF'].includes(formData.status)"
            api="cancelPayableOrder"
            :text="$t('作废')"
            type="danger"
            :params="{
              idList: [id],
            }"
            @success="init"
          />
        </div>
      </div>
      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <ModalBox
              id="BaseInfo"
              :title="$t('基本信息')"
              :showCopy="isDetail"
              @copyOrder="copyOrder(0)"
            >
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`应付单号`)">
                    <a-input disabled v-model="formData.orderSn"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`记账日期`)" required>
                    <DatePicker
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.accountingDate"
                      @choose="chooseAccountingDate"
                      :disabled="true"
                      :placehold="$t(`记账日期`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`业务日期`)">
                    <DatePicker
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.bizDate"
                      @choose="chooseBizDate"
                      :disabled="isDisabled"
                      :placehold="$t(`业务日期`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`单据类型`)" required>
                    <SelectDocumentType
                      :docType="docType"
                      :code.sync="formData.orderType"
                      :disabled="isDisabled || isAdjust"
                      @change="changeOrderType"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算组织`)" required>
                    <CommonSelect
                      :isBu="true"
                      :list="$store.state.settlementBuList"
                      :disabled="isDisabled"
                      :code.sync="formData.businessUnitCode"
                      :name.sync="formData.businessUnitName"
                      @change="changeBU"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <CommonPayeeSelect
                    :orderType="formData.orderType"
                    :type.sync="formData.payeeType"
                    :code.sync="formData.payeeCode"
                    :name.sync="formData.payeeName"
                    :disabled="isDisabled"
                    :businessUnitCode="formData.businessUnitCode"
                  />
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`业务单号`)">
                    <a-input
                      :disabled="isDetail"
                      v-model="formData.bizOrderSn"
                      :placeholder="$t(`业务单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`预到货通知单号`)">
                    <a-input
                      :disabled="isDetail"
                      v-model="formData.asnOrderSn"
                      :placeholder="$t(`预到货通知单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`入库单号`)">
                    <a-input
                      :disabled="isDetail"
                      v-model="formData.receivedOrderSn"
                      :placeholder="$t(`入库单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`跟踪单号`)">
                    <a-input
                      :disabled="isDetail"
                      v-model="formData.referenceNo"
                      :placeholder="$t(`跟踪单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`备注`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.remark"
                      :placeholder="$t(`备注`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t(`状态`)">
                    <a-input
                      disabled
                      v-model="payableOrderStatusMapping[formData.status]"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t(`是否生成凭证`)">
                    <a-input
                      disabled
                      :value="+formData.voucherGenerated ? $t('是') : $t('否')"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="!isDetail">
                  <a-form-model-item :label="$t(`是否需要生成凭证`)" required>
                    <a-select
                      v-model="formData.needGenerateVoucher"
                      :placeholder="$t(`请选择`)"
                      style="width: 100%"
                    >
                      <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
            <ModalBox id="AmountInfo" :title="$t('金额信息')">
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`本位币`)" required>
                    <SelectCurrency :code="formData.functionalCurrency" :disabled="true" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算货币`)" required>
                    <SelectCurrency
                      :code.sync="formData.settlementCurrency"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item required :label="$t(`商品总金额`)">
                    <PriceInput
                      disabled
                      :currency="formData.settlementCurrency"
                      :value="formData.amountWithoutTax"
                      :placeholder="$t(`商品总金额`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`税率`)" required>
                    <a-input-number
                      style="width: 100%"
                      :disabled="isDisabled"
                      v-model="formData.taxRate"
                      :placeholder="$t(`税率`)"
                      @blur="inputVATRateFn"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`税额`)">
                    <PriceInput
                      disabled
                      :currency="formData.settlementCurrency"
                      :value="formData.taxAmount"
                      :placeholder="$t(`税额`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`其他费用`)">
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :disabled="isDisabled"
                      :value.sync="formData.otherFees"
                      :placeholder="$t(`其他费用`)"
                      @blur="inputOtherFeesFn"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`订单总金额（含税）`)">
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :disabled="true"
                      :value.sync="formData.payableAmount"
                      :placeholder="$t(`商品总金额+销售增值税+其他费用`)"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
            <ModalBox id="InvoiceInfo" :title="$t('发票信息')" v-if="invoiceList.length > 0">
              <a-row :gutter="16" v-for="(item, index) in formData.invoiceList" :key="index">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`发票号码`)">
                    <a-input :value="item.invoiceNo" disabled />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`发票代码`)">
                    <a-input :value="item.invoiceCode" disabled />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`开票金额`)">
                    <PriceInput :value="item.amount" :disabled="true" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
          </a-form-model>
          <ModalBox id="ProductInfo" :title="$t('订单明细')">
            <a-radio-group
              class="mb8"
              v-model="detailType"
              button-style="solid"
              @change="scrollToBottom"
            >
              <a-radio-button value="goods">{{ $t('物料明细') }}</a-radio-button>
              <a-radio-button value="paymentPlan">{{ $t('付款计划') }}</a-radio-button>
            </a-radio-group>
            <div v-show="detailType === 'goods'">
              <div class="pricing-method flex-ct">
                <a-form-model-item :label="$t(`计价方式`)" required>
                  <a-select
                    :disabled="isDisabled"
                    :placeholder="$t(`请选择计价方式`)"
                    v-model="calculateTypeNew"
                    @change="scrollToBottom"
                    style="width: 300px"
                  >
                    <a-select-option value="BY_TOTAL">
                      {{ $t('通过小计计算单价') }}
                    </a-select-option>
                    <a-select-option value="BY_UNIT">
                      {{ $t('通过单价计算小计') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <div class="mt20 ml20" v-if="calculateTypeNew === 'BY_UNIT'">
                  <a-popover placement="topLeft">
                    <template slot="title">
                      <div>
                        {{ $t('若开启：含税单价可录入，若关闭：单价可录入') }}
                      </div>
                    </template>
                    <span>{{ $t('录入含税单价') }}</span>
                    <a-icon type="question-circle" class="ml6 mr20" />
                  </a-popover>
                  <a-switch v-model="byUnitTaxPrice" :disabled="isDisabled" />
                </div>
              </div>
              <div v-if="!isDisabled" style="display: flex; justify-content: space-between">
                <div style="position: relative; flex: 1; display: flex; align-items: center">
                  <CommonQuerySelect
                    v-if="['EXPENSE', 'OTHER'].includes(formData.orderType)"
                    style="width: 300px"
                    api="getExpenseItemList"
                    :placeholder="$t(`费用项目`)"
                    @change="handleChangeExpense"
                  />
                  <SkuQuickQueryModal v-else style="width: 300px" @selected="handleChangeSku" />
                  <a-button type="primary" style="margin-left: 15px" @click="addGoodsToTable">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('添加') }}
                  </a-button>
                </div>
                <div class="flex-ct txt fz16" style="font-weight: bold">
                  <div class="mr30 flex-ct">
                    {{ $t('数量合计') }}: {{ purchaseAllQuantity | toThousands }}
                  </div>
                  <div class="mr30 flex-ct">
                    {{ $t('总金额合计') }}:
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :value="purchaseAllAmount"
                      :showTxt="true"
                    />
                  </div>
                  <div class="flex-ct">
                    {{ $t('总价税合计') }}:
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :value="totalPayableAmount"
                      :showTxt="true"
                    />
                  </div>
                </div>
              </div>
              <div class="table-wrapper" style="margin-top: 10px">
                <a-table
                  :columns="columns"
                  :dataSource="tableData"
                  bordered
                  size="middle"
                  :loading="tableLoading"
                  :pagination="false"
                  :scroll="{ x: 1500 }"
                  :rowKey="(record, index) => index"
                >
                  <span slot="discountAmountTitle">
                    <a-tooltip>
                      <template slot="title">
                        {{ $t('当单价乘以数量与小计不等时展示优惠金额') }}
                      </template>
                      {{ $t(`优惠金额`) }}
                      <a-icon type="question-circle" />
                    </a-tooltip>
                  </span>
                  <span slot="no" slot-scope="text, record, index">
                    {{ index + 1 }}
                  </span>
                  <span slot="productName" slot-scope="text, record">
                    <div v-if="record.itemName">{{ $t('名称') }}:{{ record.itemName }}</div>
                    <div v-if="record.gtin">{{ $t('代码') }}:{{ record.gtin }}</div>
                  </span>
                  <template slot="itemName" slot-scope="text">
                    <div>{{ text }}</div>
                    <a-tag v-if="formData.sourceOrderType" color="blue">
                      {{
                        sourceOrderTypeMappings[formData.sourceOrderType] ||
                        formData.sourceOrderType
                      }}
                    </a-tag>
                  </template>
                  <template slot="itemStyle" slot-scope="text">
                    {{ text }}
                  </template>
                  <span slot="unit" slot-scope="text, record">
                    <SelectUnit
                      :disabled="isDisabled"
                      :list="record.unitList"
                      :code.sync="record.rawUnit"
                    />
                  </span>
                  <span slot="taxAmount" slot-scope="text, record, index">
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :value.sync="record.taxAmount"
                      :showTxt="!isAdjust"
                      @blur="(value) => handleChange(value, 'taxAmount', index)"
                    />
                  </span>

                  <template slot="itemType" slot-scope="text, record">
                    <CommonSelect
                      :list="$store.state.expense_type"
                      :disabled="isDisabled || formData.orderType === 'OTHER'"
                      :code.sync="record.itemType"
                      :name.sync="record.itemTypeName"
                    />
                  </template>
                  <template slot="departmentType" slot-scope="text, record">
                    <CommonQuerySelect
                      api="getDepartmentList"
                      :params="{
                        typeList: [1],
                      }"
                      :placeholder="$t('使用部门')"
                      :disabled="isDisabled"
                      :code.sync="record.departmentCode"
                      :name.sync="record.departmentName"
                      @change="
                        (item) => {
                          changeDepartment(item, record)
                        }
                      "
                    />
                  </template>
                  <span slot="action" slot-scope="text, record, index">
                    <a @click="onDelect(index)">
                      <a-icon type="delete" style="color: red" />
                    </a>
                  </span>
                  <span slot="payableAmount" slot-scope="text, record, index">
                    <div v-if="!isDisabled">
                      <PriceInput
                        :currency="formData.settlementCurrency"
                        :value="text"
                        :placeholder="$t(`请输入`)"
                        @blur="(val) => handleChangePayableAmount(val, index)"
                      />
                    </div>
                    <span v-else>
                      <PriceInput
                        :currency="formData.settlementCurrency"
                        :value="text"
                        :showTxt="true"
                      />
                    </span>
                  </span>
                  <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                    <div :key="col">
                      <!-- includes 用来判断当前的输入类型 -->
                      <div v-if="!isDisabled">
                        <a-input-number
                          :placeholder="$t(`请输入`)"
                          :formatter="Formatter"
                          :parser="Formatter"
                          :disabled="isAdjust"
                          v-if="col === 'taxRate' || col === 'rawQuantity'"
                          :value="text"
                          @blur="(e) => handleChange(e.target.value, col, index)"
                        />
                        <PriceInput
                          :currency="formData.settlementCurrency"
                          v-else-if="col === 'unitPrice' || col === 'unitPriceWithTax'"
                          :placeholder="$t(`请输入`)"
                          :disabled="getUnitPriceDisabled(col)"
                          :value="text"
                          @blur="(val) => handleChange(val, col, index)"
                        />
                        <PriceInput
                          :currency="formData.settlementCurrency"
                          v-else-if="col === 'amountWithoutTax'"
                          :placeholder="$t(`请输入`)"
                          :disabled="calculateTypeNew === 'BY_UNIT'"
                          :value="text"
                          @blur="(val) => handleChange(val, col, index)"
                        />
                        <a-input
                          :placeholder="$t(`请输入`)"
                          v-else-if="inputScopedSlots.includes(col)"
                          :value="text"
                          @change="(e) => handleChange(e.target.value, col, index)"
                        />
                        <span v-else>
                          <PriceInput
                            :currency="formData.settlementCurrency"
                            :value="text"
                            :showTxt="true"
                          />
                        </span>
                      </div>
                      <span v-else-if="col === 'taxRate' || col === 'rawQuantity'">
                        {{ text }}
                      </span>
                      <span v-else>
                        <PriceInput
                          :currency="formData.settlementCurrency"
                          :value="text"
                          :showTxt="true"
                        />
                      </span>
                    </div>
                  </template>
                </a-table>
              </div>
            </div>
            <div v-show="detailType === 'paymentPlan'">
              <div class="table-header flex-ct between pb10">
                <div>
                  <a-popover placement="topLeft">
                    <template slot="content">
                      <div>
                        {{ $t('打开：录入应付比例 (%) ，应付金额根据应付比例 (%) 自动计算；') }}
                      </div>
                      <div>
                        {{ $t('关闭：录入应付金额，应付比例 (%) 根据应付金额自动计算。') }}
                      </div>
                    </template>
                    <span>{{ $t('按比例') }}(%)</span>

                    <a-icon type="question-circle" class="ml6 mr20" />
                  </a-popover>
                  <a-switch v-model="byPercent" :disabled="isDisabled" />
                </div>
                <div class="option-btns pr20" v-if="!isDisabled">
                  <span class="text-link fz16" @click="addPaymentPlan({})">
                    {{ $t('增行') }}
                  </span>
                  <span class="text-link fz16 ml10" @click="deletePaymentPlan">
                    {{ $t('删行') }}
                  </span>
                </div>
              </div>

              <CommonTable
                :columns="paymentPlanColumns"
                :dataSource="showPaymentPlanList"
                :scroll="{ x: 1500 }"
                :showSelect="!isDisabled"
                :showPagination="false"
                :showSetting="false"
                :selectedRowKeys.sync="selectedRowKeys"
              >
                <template v-slot:isPrepay="{ record }">
                  <a-checkbox v-model="record.isPrepay" :disabled="isDisabled" />
                </template>
                <template v-slot:dueDate="{ record }">
                  <DatePicker
                    :needhms="false"
                    style="background-color: #ffffff; width: 100%"
                    :init-date-time="record.dueDate"
                    @choose="
                      (data) => {
                        chooseDueDate(record, data)
                      }
                    "
                    :disabled="isDisabled"
                  />
                </template>
                <template v-slot:payableRatio="{ text, record, index }">
                  <a-input-number
                    v-if="byPercent"
                    style="width: 100%"
                    v-model="record.payableRatio"
                    :disabled="isDisabled"
                    :placeholder="$t('请输入')"
                    @blur="checkLessPercent(record, index)"
                  />
                  <span v-else>{{ Number(text) }}</span>
                </template>
                <template v-slot:payableAmount="{ text, record, index }">
                  <PriceInput
                    v-if="!byPercent"
                    :value.sync="record.payableAmount"
                    :disabled="isDisabled"
                    :placeholder="$t('请输入')"
                    @blur="
                      () => {
                        checkLessAmount(record, index)
                      }
                    "
                  />
                  <span v-else>
                    <PriceInput
                      :currency="formData.settlementCurrency"
                      :value="text"
                      :showTxt="true"
                    />
                  </span>
                </template>
              </CommonTable>
            </div>
          </ModalBox>
          <ModalBox id="WrittenOffInfo" :title="$t('核销关系')" v-if="isDetail">
            <WrittenOffRelation
              :docSn="sn || formData.orderSn"
              :businessUnitCode="formData.businessUnitCode"
              @success="getDetailInfo"
            />
          </ModalBox>
        </section>
        <OperationLog
          ref="OperationLogRef"
          :scrollHeight="scrollHeight"
          :actionSn="sn"
          :type="docType"
          v-if="isDetail"
        />
      </div>

      <BottomBtns
        :isEdit.sync="isEdit"
        :isDetail="isDetail"
        :draftLoading="draftLoading"
        :saveLoading="saveLoading"
        :status="formData.status"
        @submit="onSubmit"
        @cancel="getDetailInfo"
        @back="backForm"
      />
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import SelectCurrency from '@component/selectCurrency'
import SelectUnit from '@component/selectUnit'
import CommonSelect from '@component/commonSelect'
import { add, divide, multiply, subtract } from '@/common/number'
import SkuQuickQueryModal from '@component/skuQuickQueryModal'
import DatePicker from '@component/datePicker'
import CommonTable from '@component/commonTable'
import PushBtn from '@component/pushBtn'
import VoucherBtn from '@component/voucherBtn'
import BottomBtns from '@component/bottomBtns'
import PriceInput from '@component/priceInput'
import OperationLog from '@component/operationLog'
import formatter from '@/common/formatter'
import deepClone from '@/common/deepClone'
import {
  toFixedUp,
  convertKeysToCamelCase,
  getUnitRate,
  goBack,
  fetchDocumentMappings,
} from '@/common'
import debounce from '@/common/debounce'
import CommonPayeeSelect from '@component/commonPayeeSelect'
import SelectDocumentType from '@component/selectDocumentType'
import WrittenOffRelation from '@component/writtenOffRelation'

export default {
  name: 'payableDetail',
  components: {
    SkuQuickQueryModal,
    DatePicker,
    SelectCurrency,
    SelectUnit,
    CommonSelect,
    BottomBtns,
    CommonTable,
    PushBtn,
    PriceInput,
    VoucherBtn,
    OperationLog,
    CommonPayeeSelect,
    SelectDocumentType,
    WrittenOffRelation,
  },
  data() {
    return {
      id: '',
      sn: '',
      docType: 'PayableOrder',
      isAdjust: false,
      isCopy: false,
      loading: false,
      visible: false,
      isDetail: false, //是否是详情页
      isEdit: false, //是否是详情页
      // 表格数据
      tableData: [],
      // 每一列的插槽名 - 表格行内编辑用
      customRenderList: ['rawQuantity', 'unitPrice', 'amountWithoutTax', 'unitPriceWithTax'],
      // 用来匹配插槽中显示input框
      inputScopedSlots: ['rawQuantity', 'unitPrice', 'amountWithoutTax', 'unitPriceWithTax'],
      // 对于某些自动赋值的input框设为 只读
      // 表格loading
      tableLoading: false,
      // 表格选中key
      selectedRowKeys: [],
      formData: {
        payeeType: 'SUPPLIER',
        payeeCode: undefined,
        payeeName: undefined,
        accountingDate: undefined,
        bizDate: undefined,
        warehouseCode: undefined,
        invoiceType: undefined,
        taxRate: 0,
        taxAmount: undefined,
        amountWithoutTax: undefined,
        payableAmount: undefined,
        settlementCurrency: 'CNY',
        invoiceStatus: 'WAIT_INVOICE',
        status: 'DRAFT',
        needGenerateVoucher: undefined,
      },
      currentGood: {},
      purchaseAllAmount: 0,
      purchaseAllQuantity: 0,
      totalPayableAmount: 0,
      supplierIndex: undefined,
      draftLoading: false,
      saveLoading: false,
      calculateTypeNew: 'BY_TOTAL',
      paymentPlanList: [],
      invoiceList: [],
      detailType: 'goods',
      byPercent: true,
      supplierVisible: false,
      byUnitTaxPrice: true,
      sourceOrderTypeMappings: {},
    }
  },
  async mounted() {
    const mappings = await fetchDocumentMappings(this.docType, ['sourceOrderType'])
    this.sourceOrderTypeMappings = mappings.sourceOrderType || {}
  },
  activated() {
    this.init()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data())
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  computed: {
    ...mapState(['payable_order_type']),
    ...mapGetters(['payableOrderStatusMapping', 'goodsTypeMapping', 'expenseTypeMapping']),
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    columns() {
      const othersColumns = ['EXPENSE', 'OTHER'].includes(this.formData.orderType)
        ? [
            {
              title: this.$t('费用名称'),
              dataIndex: 'itemName',
              width: 120,
              scopedSlots: {
                customRender: 'itemName',
              },
            },
            {
              title: this.$t('费用类型'),
              dataIndex: 'itemType',
              width: 200,
              scopedSlots: {
                customRender: 'itemType',
              },
            },
            {
              title: this.$t('使用部门'),
              dataIndex: 'departmentType',
              width: 200,
              scopedSlots: {
                customRender: 'departmentType',
              },
            },
          ]
        : [
            {
              title: this.$t('商品信息'),
              dataIndex: 'productName',
              width: 200,
              scopedSlots: {
                customRender: 'productName',
              },
            },
            {
              title: this.$t('商品规格'),
              align: 'center',
              dataIndex: 'itemStyle',
              width: 120,
              scopedSlots: {
                customRender: 'itemStyle',
              },
            },
            {
              title: this.$t('商品类型'),
              align: 'center',
              dataIndex: 'itemType',
              width: 120,
              customRender: (text) => this.goodsTypeMapping[text],
            },
            {
              align: 'center',
              dataIndex: 'unit',
              width: 100,
              title: this.$t('单位'),
              scopedSlots: {
                customRender: 'unit',
              },
            },
          ]
      let list = [
        {
          title: '#',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        ...othersColumns,
        {
          title: this.$t('数量'),
          align: 'center',
          dataIndex: 'rawQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'rawQuantity',
          },
        },
        {
          title: this.$t('单价'),
          align: 'center',
          dataIndex: 'unitPrice',
          width: 120,
          scopedSlots: {
            customRender: 'unitPrice',
          },
        },
        {
          title: this.$t('税率') + '(%)',
          align: 'center',
          dataIndex: 'taxRate',
          width: 120,
          customRender: (text) => text && Number(text),
        },
        {
          title: this.$t('税额'),
          align: 'center',
          dataIndex: 'taxAmount',
          width: 120,
          scopedSlots: {
            customRender: 'taxAmount',
          },
        },
        {
          title: this.$t('含税单价'),
          align: 'center',
          dataIndex: 'unitPriceWithTax',
          width: 120,
          scopedSlots: {
            customRender: 'unitPriceWithTax',
          },
        },
        {
          title: this.$t('小计金额'),
          align: 'center',
          dataIndex: 'amountWithoutTax',
          width: 120,
          scopedSlots: {
            customRender: 'amountWithoutTax',
          },
        },
        {
          align: 'center',
          dataIndex: 'discountAmount',
          width: 120,
          slots: { title: 'discountAmountTitle' },
          customRender: (text) => this.showPrice(Number(text)),
        },
        {
          title: this.$t('价税合计'),
          align: 'center',
          dataIndex: 'payableAmount',
          width: 120,
          scopedSlots: {
            customRender: 'payableAmount',
          },
        },
      ]
      if (this.isEdit || !this.isDetail) {
        list.push({
          title: this.$t('操作'),
          align: 'center',
          width: 120,
          fixed: 'right',
          scopedSlots: {
            customRender: 'action',
          },
        })
      }
      return list
    },
    scrollHeight() {
      return window.innerHeight - 280 + 'px'
    },
    paymentPlanColumns() {
      let list = [
        {
          title: this.$t('是否预付'),
          dataIndex: 'isPrepay',
          align: 'center',
          width: 100,
          scopedSlots: {
            customRender: 'isPrepay',
          },
        },
        {
          title: this.$t('到期日'),
          dataIndex: 'dueDate',
          width: 180,
          scopedSlots: {
            customRender: 'dueDate',
          },
        },
        {
          title: this.$t('应付比例') + '(%)',
          dataIndex: 'payableRatio',
          scopedSlots: {
            customRender: 'payableRatio',
          },
          width: 180,
        },
        {
          title: this.$t('应付金额'),
          dataIndex: 'payableAmount',
          scopedSlots: {
            customRender: 'payableAmount',
          },
          width: 180,
        },
      ]
      if (this.isDetail) {
        list.push(
          ...[
            {
              title: this.$t('已锁定金额'),
              dataIndex: 'lockAmount',
              customRender: (text) => this.showPrice(text),
            },
            {
              title: this.$t('未锁定金额'),
              dataIndex: 'unLockAmount',
              customRender: (text, record) =>
                this.showPrice(subtract(record.payableAmount, record.lockAmount || 0)),
            },
            {
              title: this.$t('已核销金额'),
              dataIndex: 'writtenOffAmount',
              customRender: (text) => this.showPrice(text),
            },
            {
              title: this.$t('未核销金额'),
              dataIndex: 'unWrittenOffAmount',
              customRender: (text, record) =>
                this.showPrice(subtract(record.payableAmount, record.writtenOffAmount || 0)),
            },
            {
              title: this.$t('冻结状态'),
              dataIndex: 'status',
              customRender: (text) => (text === 'NORMAL' ? this.$t('未冻结') : this.$t('已冻结')),
            },
          ]
        )
      }
      return list
    },
    showPaymentPlanList() {
      return this.paymentPlanList.filter((item) => item.showStatus !== -1)
    },
  },
  methods: {
    Formatter: formatter,
    init() {
      this.isDetail = false
      this.isEdit = false
      this.isCopy = false
      this.isAdjust = false
      this.selectedRowKeys = []
      if (!this.$route.query.id) {
        Object.assign(this.$data, this.$options.data())
        this.formData.bizDate = moment().format('YYYY-MM-DD')
        this.formData.accountingDate = moment().format('YYYY-MM-DD')
      } else {
        this.id = this.$route.query.id
        this.sn = this.$route.query.sn
        this.isDetail = true
        this.$nextTick(() => {
          this.$refs.OperationLogRef.queryList()
        })
      }
      this.getDetailInfo()
    },
    changeBU(value) {
      this.formData.businessUnitCode = value.code
      this.formData.businessUnitName = value.name
      this.formData.functionalCurrency = value.currency
    },
    showPrice(num) {
      if (num) {
        return this.$currencySymbol(num, this.formData.settlementCurrency)
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector('.fixContent').scrollTo(0, 2000)
      })
    },
    setTotalAmount(skip = false) {
      this.calcAllAmount()
      let otherFees = this.formData.otherFees
      otherFees = otherFees === undefined ? 0 : this.formData.otherFees * 1
      let result = this.formData.amountWithoutTax * 1 + this.formData.taxAmount * 1 + otherFees
      this.formData.payableAmount = isNaN(result) ? '' : Number(result.toFixed(4))
      if (!skip) {
        this.calPaymentPlan()
      }
    },
    async getDetailInfo() {
      let payableOrderFormdata = localStorage.getItem('payableOrderFormdata')
      if (this.id) {
        this.loading = true
        let res = await http({
          url: api.getPayableDetail,
          type: 'post',
          data: {
            id: this.id,
          },
        })
        let result = convertKeysToCamelCase(res.result)
        this.tableData = deepClone(result.detailList).map((item) => {
          if (item.unitList) {
            item.unitList = JSON.parse(item.unitList)
          }
          return item
        })
        this.paymentPlanList = result.planList.map((item) => {
          item.isPrepay = Boolean(item.isPrepay)
          return item
        })
        this.invoiceList = result.invoiceList
        let formData = result
        this.formData = formData
        if (result.status === 'DRAFT') {
          this.isEdit = true
        }
        if (this.formData.amountWithoutTax) {
          this.formData.taxRate = (
            divide(this.formData.taxAmount, this.formData.amountWithoutTax) * 100
          ).toFixed(2)
        }
        this.$forceUpdate()
        this.setTotalAmount(1)
      } else if (payableOrderFormdata) {
        this.isCopy = true
        let data = JSON.parse(payableOrderFormdata)
        // console.log('data: ', data)
        this.formData = data
        this.formData.sourceOrderCode = undefined
        this.formData.sourceOrderType = undefined
        this.formData.bizOrderSn = undefined
        this.formData.asnOrderSn = undefined
        this.formData.receivedOrderSn = undefined
        this.formData.referenceNo = undefined
        this.formData.orderSn = undefined
        this.formData.id = undefined
        this.formData.status = 'DRAFT'

        if (this.$route.query.isAdjust) {
          this.isAdjust = true
          this.formData.sourceOrderType = this.docType
          this.formData.sourceOrderCode = this.formData.orderSn
          this.formData.orderType = 'ADJUSTMENT'
        }

        this.tableData = deepClone(this.formData.tableData)
        this.paymentPlanList = deepClone(this.formData.paymentPlanList)
        this.invoiceList = deepClone(this.formData.invoiceList)
        this.formData.accountingDate = moment().format('YYYY-MM-DD')
        delete this.formData.tableData
        delete this.formData.paymentPlanList
        delete this.formData.invoiceList
        localStorage.removeItem('payableOrderFormdata')
        this.setTotalAmount()

        if (this.$route.query.isAdjust) {
          this.calPaymentPlan()
        }
      }
      this.loading = false
    },
    chooseEstimatedArrivalTime(data) {
      this.formData.estimatedArrivalTime = data.data
    },
    chooseAccountingDate(data) {
      this.formData.accountingDate = data.data
    },
    chooseBizDate(data) {
      this.formData.bizDate = data.data
    },
    handleChangeSku(data) {
      this.currentGood = {
        amountWithoutTax: '',
        baseUnit: '',
        discountAmount: '',
        discountRate: '',
        gtin: data.goodsCode,
        itemName: data.goodsName,
        skuStyleList: Object.entries(data.selectedSpecs || {}).map(([key, value]) => {
          return {
            name: key,
            styleValue: value,
          }
        }),
        payableAmount: '',
        quantity: '',
        rawQuantity: '',
        rawUnit: '',
        taxAmount: '',
        taxRate: this.formData.taxRate,
        unitPrice: '',
        unitPriceWithTax: '',
        unitList: data.unitList || [],
        itemType: data.goodsType === 'RAW_MATERIAL' ? 'RAW_MATERIAL' : 'FINISH_PRODUCT',
      }
    },
    handleChangeExpense(data) {
      this.currentGood = {
        amountWithoutTax: '',
        baseUnit: '',
        discountAmount: '',
        discountRate: '',
        gtin: data.code,
        itemName: data.name,
        skuStyleList: [],
        payableAmount: '',
        quantity: '',
        rawQuantity: '',
        rawUnit: '',
        taxAmount: '',
        taxRate: this.formData.taxRate,
        unitPrice: '',
        unitPriceWithTax: '',
        unitList: [],
        itemType: this.formData.orderType === 'OTHER' ? 'NONE' : '',
      }
    },
    handleChange(value, colName, index) {
      const newData = [...this.tableData]
      const target = newData[index]
      if (target) {
        target[colName] = value
        this.calcGoodsAmount()
        this.tableData = newData
      }
    },
    // 用户直接输入价税合计，反向推算小计、税额、单价等
    handleChangePayableAmount(value, index) {
      const newData = [...this.tableData]
      const target = newData[index]
      if (!target) return
      target.payableAmount = value
      const taxRate = Number(this.formData.taxRate || 0)
      const rate = taxRate / 100
      if (value) {
        const amountWithoutTax = +Number(value / (1 + rate)).toFixed(4)
        const taxAmount = +Number(value - amountWithoutTax).toFixed(4)
        target.amountWithoutTax = amountWithoutTax
        target.taxAmount = taxAmount
        if (target.rawQuantity) {
          target.unitPrice = +toFixedUp(divide(amountWithoutTax, target.rawQuantity), 4)
          target.unitPriceWithTax = +Number(divide(value, target.rawQuantity)).toFixed(4)
        }
        // 优惠金额：小计与单价×数量的差异
        if (target.rawQuantity && target.unitPrice) {
          const calTotalAmount = +multiply(target.rawQuantity, target.unitPrice)
          target.discountAmount = +(calTotalAmount - amountWithoutTax).toFixed(4)
        }
      }
      this.tableData = newData
      this.setTotalAmount()
    },
    calcGoodsAmount() {
      this.getTheAmountInPcFn()
    },
    calcAllAmount() {
      let quantity = 0,
        amount = 0,
        taxAmount = 0,
        totalAmount = 0
      this.tableData.forEach((item) => {
        quantity = add(quantity, item.rawQuantity)
        amount = add(amount, item.amountWithoutTax)
        taxAmount = add(taxAmount, item.taxAmount)
        totalAmount = add(totalAmount, item.payableAmount)
      })
      this.purchaseAllQuantity = quantity
      this.totalPayableAmount = totalAmount
      this.formData.amountWithoutTax = this.purchaseAllAmount = amount
      this.formData.taxAmount = taxAmount
    },
    onDelect(index) {
      this.tableData.splice(index, 1)
      this.$nextTick(() => {
        this.calcGoodsAmount()
      })
    },
    addGoodsToTable() {
      if (this.currentGood.itemName) {
        this.currentGood.itemStyle = this.currentGood.skuStyleList
          .map((item) => item.styleValue)
          .join(';')
        let procurementUnitItem =
            this.currentGood.unitList?.find((item) => item.procurementUnit) || {},
          baseUnitItem = this.currentGood.unitList?.find((item) => item.baseUnit) || {}
        this.currentGood.rawUnit = procurementUnitItem.unitNameFull || baseUnitItem.unitNameFull
        this.currentGood.baseUnit = baseUnitItem.unitNameFull
        if (
          this.tableData.length &&
          this.tableData.findIndex((i) => i.gtin == this.currentGood.gtin) !== -1
        ) {
          return this.$message.error(this.$t('该商品已存在，不可重复添加'))
        }
        this.tableData.push(this.currentGood)
        this.scrollToBottom()
      }
    },
    getTheAmountInPcFn() {
      if (!this.tableData.length) return
      let hasEmpty = false
      this.tableData.forEach((item) => {
        // console.log(item)
        item.taxRate = this.formData.taxRate || 0
        if (!this.isAdjust) {
          item.taxAmount = 0
        }
        if (
          item.rawQuantity &&
          (item.unitPrice || item.unitPriceWithTax || item.amountWithoutTax)
        ) {
          //修改单价和数量 小计跟着改
          if (this.calculateTypeNew === 'BY_TOTAL') {
            item.unitPrice = +toFixedUp(divide(item.amountWithoutTax, item.rawQuantity), 4)
            item.unitPriceWithTax = +multiply(
              divide(item.amountWithoutTax, item.rawQuantity),
              1 + item.taxRate / 100
            ).toFixed(4)
            if (!this.isAdjust) {
              item.taxAmount = +this.getAmountByRatio(item.taxRate || 0, item.amountWithoutTax)
            }
            item.payableAmount = +add(item.amountWithoutTax, item.taxAmount).toFixed(4)
            let calTotalAmount = +multiply(item.rawQuantity, item.unitPrice)
            item.discountAmount = +(calTotalAmount - item.amountWithoutTax).toFixed(4)
          } else {
            if (this.byUnitTaxPrice) {
              item.unitPrice = +toFixedUp(item.unitPriceWithTax * (1 / (1 + item.taxRate / 100)), 4)
            } else {
              item.unitPriceWithTax = +(item.unitPrice * (1 + item.taxRate / 100)).toFixed(4)
            }
            item.amountWithoutTax = +multiply(item.unitPrice, item.rawQuantity).toFixed(4)
            if (!this.isAdjust) {
              item.taxAmount = +this.getAmountByRatio(item.taxRate, item.amountWithoutTax)
            }
            item.payableAmount = +multiply(item.unitPriceWithTax, item.rawQuantity).toFixed(4)
            item.discountAmount = 0
            if (this.byUnitTaxPrice) {
              item.discountAmount = +(
                add(item.amountWithoutTax, item.taxAmount).toFixed(4) - item.payableAmount
              ).toFixed(4)
            }
          }
        } else {
          hasEmpty = true
        }
      })
      if (hasEmpty) return
      this.setTotalAmount()
    },
    // 输入增值税率
    inputVATRateFn: debounce(function () {
      this.getTheAmountInPcFn()
    }),
    // 输入其他费用
    inputOtherFeesFn: debounce(function () {
      this.setTotalAmount()
    }),
    // onEdit() {
    //   this.isDetail = false
    //   this.tableData.forEach((item) => {
    //     item.editable = true
    //   })
    // },
    verification() {
      this.tableData.forEach((res) => {
        if (!res.rawQuantity) {
          this.$warning({
            title: this.$t(`警告`),
            content: this.$t(`请填写数量`),
          })
          throw Error()
        }
      })
      return Promise.resolve()
    },
    backForm(back = 0) {
      goBack('payableList', back)
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    copyOrder(isAdjust) {
      let url = 'payableDetail'
      if (isAdjust) {
        //调整单金额为负
        this.formData.tableData = this.tableData.map((item) => {
          item.amountWithoutTax = -item.amountWithoutTax
          item.taxRate = ''
          item.taxAmount = -item.taxAmount
          item.payableAmount = -item.payableAmount
          return item
        })
        this.formData.taxRate = ''
        this.paymentPlanList = []
        this.addPaymentPlan({ ratio: 100 })
        this.formData.paymentPlanList = this.paymentPlanList.map((item) => {
          return { ...item, payableAmount: -item.payableAmount }
        })
        url += '?isAdjust=1'
      } else {
        this.formData.tableData = this.tableData
        this.formData.paymentPlanList = this.paymentPlanList
      }
      this.formData.invoiceList = this.invoiceList
      let data = JSON.stringify(this.formData)
      localStorage.setItem('payableOrderFormdata', data)
      this.$router.push(url)
    },
    addPaymentPlan({ ratio, amount, due_date, index }) {
      let payableRatio = '',
        payableAmount = '',
        dueDate = '',
        amountWithoutTax = ''
      if (ratio) {
        payableRatio = ratio
        payableAmount = +this.getAmountByRatio(ratio)
        amountWithoutTax = +this.getAmountByRatio(ratio, this.formData.amountWithoutTax)
      } else if (amount) {
        payableAmount = +amount
        payableRatio = +this.getRatioByAmount(amount)
        amountWithoutTax = +this.getRatioByAmount(amount, this.formData.amountWithoutTax)
      }
      if (due_date) {
        dueDate = due_date
      }

      let taxRate = this.formData.taxRate,
        taxAmount = ''
      if (amountWithoutTax && payableAmount) {
        taxAmount = Number(subtract(payableAmount, amountWithoutTax).toFixed(4))
      }
      const data = {
        isPrepay: false,
        dueDate,
        payableRatio,
        payableAmount,
        taxRate,
        taxAmount,
        amountWithoutTax,
      }
      if (index !== undefined) {
        this.paymentPlanList.splice(index, 0, data)
      } else {
        this.paymentPlanList.push(data)
      }
      this.scrollToBottom()
    },
    deletePaymentPlan() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning(this.$t(`至少选中一项`))
        return
      }
      this.paymentPlanList
        .filter((item) => item.showStatus !== -1)
        .forEach((item, index) => {
          if (this.selectedRowKeys.includes(index)) {
            this.$set(item, 'showStatus', -1)
            item.payableRatio = 0
            item.payableAmount = 0
            item.amountWithoutTax = 0
            item.taxAmount = 0
          }
        })
      this.selectedRowKeys = []
    },
    chooseDueDate(record, data) {
      record.dueDate = data.data
    },
    getAmountByRatio(ratio, amount) {
      amount = amount || this.formData.payableAmount
      return (multiply(amount, ratio) / 100).toFixed(4)
    },
    getRatioByAmount(rate, amount) {
      amount = amount || this.formData.payableAmount
      return (divide(rate, amount) * 100).toFixed(4)
    },
    calPaymentPlan() {
      if (this.paymentPlanList.length === 0) {
        this.addPaymentPlan({ ratio: 100 })
      } else {
        this.paymentPlanList.forEach((item) => {
          if (this.byPercent) {
            if (item.payableRatio) {
              this.$set(item, 'payableAmount', +this.getAmountByRatio(item.payableRatio))
            }
          } else if (item.payableAmount) {
            this.$set(item, 'payableRatio', +this.getRatioByAmount(item.payableAmount))
          }
          if (item.payableRatio) {
            item.amountWithoutTax = +this.getAmountByRatio(
              item.payableRatio,
              this.formData.amountWithoutTax
            )
          }
        })
        this.calcPaymentPlanTax()
      }
    },
    checkLessPercent(record, index) {
      if (!record.payableRatio) return
      let totalPercent = 0
      if (record.payableRatio > 100) {
        record.payableRatio = 100
        record.payableAmount = this.formData.payableAmount
      }
      record.payableAmount = this.getAmountByRatio(record.payableRatio)

      this.paymentPlanList.forEach((item) => {
        totalPercent = add(totalPercent, +item.payableRatio)
      })
      if (totalPercent > 100) {
        this.$message.error(this.$t('应付比例总和不允许大于100%'))
      } else if (totalPercent < 100) {
        this.addPaymentPlan({
          ratio: subtract(100, totalPercent),
          due_date: record.dueDate,
          index: index + 1,
        })
        this.$nextTick(() => {
          this.calPaymentPlan()
        })
      }
    },
    checkLessAmount(record, index) {
      if (!record.payableAmount) return
      let totalAmount = 0
      record.payableRatio = this.getRatioByAmount(record.payableAmount)

      this.paymentPlanList.forEach((item) => {
        totalAmount = add(totalAmount, +item.payableAmount)
      })

      if (totalAmount > this.formData.payableAmount) {
        this.$message.error(this.$t('应付金额总和不允许大于订单总金额'))
      } else if (totalAmount < this.formData.payableAmount) {
        this.addPaymentPlan({
          amount: subtract(this.formData.payableAmount, totalAmount),
          due_date: record.dueDate,
          index: index + 1,
        })
      }
      this.$nextTick(() => {
        this.calPaymentPlan()
      })
    },
    calcPaymentPlanTax() {
      this.paymentPlanList.forEach((item) => {
        item.taxRate = this.formData.taxRate
        if (item.amountWithoutTax && item.payableAmount) {
          item.taxAmount = Number(subtract(item.payableAmount, item.amountWithoutTax).toFixed(4))
        }
      })
    },
    onSubmit: debounce(async function (status) {
      if (!this.formData.payeeName) {
        this.$warning({
          title: this.$t(`警告`),
          content:
            this.$t('请选择') + this.$store.getters.contactTypeMapping[this.formData.payeeType],
        })
        return
      }
      if (this.formData.taxRate === undefined || this.formData.taxRate === null) {
        this.$warning({
          title: this.$t(`警告`),
          content: this.$t(`请填写增值税税率`),
        })
        return
      }
      if (this.tableData.length === 0) {
        this.$warning({
          title: this.$t(`警告`),
          content: this.$t(`请添加商品`),
        })
        return
      }
      await this.verification()
      const data = deepClone(this.formData)
      if (this.id) {
        data.id = this.id
      }
      data.status = status
      data.detailList = deepClone(this.tableData).map((item) => {
        let targetUnit = item.unitList.find((elem) => elem.unitNameFull === item.rawUnit) || {}
        let { rate } = getUnitRate({ list: item.unitList, targetUnit })
        item.quantity = Math.round(multiply(item.rawQuantity, rate)) || item.rawQuantity
        item.payeeType = this.formData.payeeType
        item.payeeCode = this.formData.payeeCode
        item.payeeName = this.formData.payeeName
        delete item.skuStyleList
        return item
      })
      data.paymentPlanList = this.paymentPlanList.map((item, index) => {
        item.sort = index + 1
        item.payeeType = this.formData.payeeType
        item.payeeCode = this.formData.payeeCode
        item.payeeName = this.formData.payeeName
        return item
      })
      data.merchantCode = localStorage.getItem('merchantCode')
      if (status === 'DRAFT') {
        this.draftLoading = true
      } else {
        this.saveLoading = true
      }
      try {
        await http({
          url: api.createPayableOrder,
          data: {
            payableOrder: data,
          },
          type: 'post',
          hasLoading: true,
          success: (res) => {
            if (res.success) {
              this.$message.success({
                title: this.$t(`成功`),
                content: this.$t(`保存成功`),
              })
              if (this.isDetail) {
                this.init()
              } else {
                this.backForm()
              }
            }
          },
        })
      } finally {
        this.draftLoading = false
        this.saveLoading = false
      }
    }),
    getUnitPriceDisabled(col) {
      if (this.calculateTypeNew === 'BY_TOTAL') {
        return true
      } else {
        if (this.byUnitTaxPrice) {
          return col === 'unitPrice'
        } else {
          return col === 'unitPriceWithTax'
        }
      }
    },
    pushAdjust() {
      this.copyOrder(1)
    },
    createInvoiceHandle() {
      localStorage.setItem('payableOrderPushdata', JSON.stringify(this.tableData))
      this.$router.push({
        name: 'invoiceDetail',
        query: {
          bizType: 'PURCHASE',
        },
      })
    },
    changeDepartment(item, record) {
      this.$set(record, 'departmentType', item.departmentAttrCode)
    },
    changeOrderType() {
      this.tableData.forEach((item) => {
        if (this.formData.orderType === 'OTHER') {
          item.itemType = 'NONE'
        } else if (this.formData.orderType !== 'EXPENSE') {
          item.itemType = item.goodsType === 'RAW_MATERIAL' ? 'RAW_MATERIAL' : 'FINISH_PRODUCT'
        } else {
          item.itemType = ''
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA ::v-deep .ant-modal-footer {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.inputMody {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  outline: none;
}
.inputMody::-webkit-input-placeholder {
  color: #ccc;
}
.pricing-method {
  margin-bottom: 10px;
}
</style>
